import React, { useEffect, useRef, useState } from 'react';
import DsButton from '../../common/DsButton';
import DsModal from '../../common/DsModal';
import GroupChatIconPresetPicker, { type GroupChatIconChoice } from './GroupChatIconPresetPicker';
import '../../../css/admin/chats/GroupChatIconEditor.css';
type Props = { value?: GroupChatIconChoice | null; disabled: boolean; onApply: (choice: GroupChatIconChoice) => Promise<boolean>; imageStyle?: React.CSSProperties; children?: React.ReactNode; buttonLabel?: string };
export default function GroupChatIconSelector({ value, disabled, onApply, imageStyle, children, buttonLabel = 'アイコンを変更' }: Props) {
 const [open, setOpen] = useState(false), [saving, setSaving] = useState(false);
 const active = useRef(true);
 useEffect(()=>{ active.current=true; return ()=>{active.current=false;}; },[]);
 const busy = disabled || saving;
 return <div className="group-icon-editor">
  <p className="group-icon-editor__title">アイコン</p>
  <div className="group-chat-page__iconEditor">
   <div className="group-chat-page__settingsIconPreview" aria-hidden="true" style={imageStyle || {backgroundImage:`url(/group-chat-icons/${value?.assetId || 'note'}.png)`,backgroundSize:'cover'}} />
   <DsButton variant="secondary" appearance="text" disabled={busy} onClick={()=>setOpen(true)}>{buttonLabel}</DsButton>
  </div>
  {open && <DsModal open title="アイコンを選択" ariaLabel="アイコンを選択" footer={null} onClose={()=>{if(!busy)setOpen(false);}} dismissible={!busy} size="md">
   <div className="group-icon-editor">
   {children}
   <GroupChatIconPresetPicker disabled={busy} initialChoice={value} onApply={async(choice)=>{
    setSaving(true); try { const ok=await onApply(choice); if(ok&&active.current)setOpen(false);return ok; }
    finally {if(active.current)setSaving(false);}
   }} />
   </div>
  </DsModal>}
 </div>;
}
